import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import { CostSheetModel } from "./cost-sheet-model";

export class CostingSheetResponse extends GlobalResponseObject{
    data?: CostSheetModel[];
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: CostSheetModel[]) {
        super(status, intlCode, internalMessage);
        this.data = data;
    }
}
